import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-admin-office-type',
  templateUrl: './admin-office-type.component.html',
  styleUrls: ['./admin-office-type.component.css']
})
export class AdminOfficeTypeComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  officetypes: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddofficetype = false;
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'sort', header: 'Sortering' },
      { field: 'abbreviation', header: 'Förkortning' },
      { field: 'name', header: 'Namn' }
    ];
    this.getOfficeTypes();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getOfficeTypes() {
    this.adminService.GetOfficeTypes().subscribe(data => {
      if (data) {
        this.officetypes = data;
      }
    });
  }

  saveOfficeType(evt) {
    /*  this.adminService.UpdateOfficeType(evt).subscribe(x => {
        this.display = false;
        this.messageService.add({severity:'success', summary:'Information', detail:'Uppdragstyp uppdaterad.'});
        this.getOfficeTypes();
      });*/
  }

  saveAddOfficeType(evt) {
    /*   this.adminService.AddOfficeType(evt).subscribe(resp => {
         if (resp) {
           this.messageService.add({severity:'success', summary:'Information', detail:'Uppdragstyp tillagd.'});
           this.getOfficeTypes();
         this.displayaddofficetype = false;*/
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Vill du radera vald ämbetstyp?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteOfficeType(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteOfficeType(rowdata) {
    this.adminService.RemoveOfficeType(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Ämbetstyp raderad.' });
        this.getOfficeTypes();
      }
    });
  }


  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddofficetype = false;
  }
  addCommittee() {
    this.displayaddofficetype = true;
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    let firstrow = 'Ämbetstyp Sortering;Ämbetstyp Förkortning;Ämbetstyp Namn';
    const excelrecords: any[] = [];
    this.officetypes.forEach(r => {
      const row = {
        sort: r.sort,
        abbreviation: r.abbreviation,
        name: r.name
      }
      excelrecords.push(row);
    });
    const filnamn = 'OF_officetypes';
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }
}
